<template>
    <div id="DepreciationSsetup">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a> -->
                        <router-link class="btn btn-primary" v-bind:to="{name: 'DepreciationSetup',params:{flag:'fromList'}}" >
                            <i class="fp-add"></i>    Add
                        </router-link>

                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backToList">
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li>
                                    <router-link class="" v-bind:to="{name: 'DepriciationCreate',params:{flag:'fromList'}}" >Add</router-link>
                                </li>
                                 <li>
                                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backToList">
                                        <i class="fp-back"> </i> Back
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dep-schedule-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'DepreciationSetupList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'DepreciationSetupList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listDepreciationSetup"
                                      mode="remote"
                                      title="DepreciationSetup"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: depreciation_value,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      >
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template>
                                                      <router-link title="Update Setup" class="fp-edit" v-bind:to="{name: 'DepreciationSetupEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button id="deleteDepreciationSetupBtn" v-on:click.prevent="scheduleDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import moment from 'moment';


    export default {
        name: "DepreciationSetupList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "DepreciationSchedule List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            pageTitle: "Depreciation Setup List",
            depreciation_value: true,
            hideButton:false,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                },
                
                {
                    label: 'Asset Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Residual',
                    field: 'residual',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Method", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Start Year',
                    field: 'start_year',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Capital Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: 'End Year',
                    field: 'end_year',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Capital Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 10
            },
            loading:false,
            error:"",
            pageKey:"_depreciation_setup_list_",
            action:'list',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_depreciation_schedule') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },

        mounted: function() {
            var self = this;
            //self.loadList();

            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listDepreciationSetup.unselectAllInternal();
            },
            // exportCheck: function() {
            //     var self = this;
            //     var count = 0;
            //     var actionFlag = "";
            //     var data = this.$refs['listDepreciationSetup'].selectedRows;
            //     count = data.length;

            //     if(count != 0 && count < 100){
            //       actionFlag = "export";
            //     }

            //     this.exportReports(actionFlag);
            // },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },

            loadList() {
                var self = this;
                self.loading = true;
                 var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listDepreciationSetup'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listDepreciationSetup'].selectedRows[i].id)
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    selectedRows:selectedRows,
                    selectedAll:self.serverParams.selectedAll

                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/depreciation-setup/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "delete") {
                                self.action = "list";
                                self.$refs.listDepreciationSetup.unselectAllInternal();
                                self.loadList();
                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-inventory-list')

                    }
                });
            },
           
            scheduleDelete:function(){
                var self = this;
               
                if (confirm('Are you sure that you want to delete this Depreciation Setup? ')) {
                    self.action = 'delete';
                    self.loadList();
                }
            },
            backToList: function(){
                var self = this;
                self.$router.push('/depreciation-schedule/list');

            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/DepreciationSetupList.vue